<template>
  <b-navbar class="shadow text-white mainnav" small type="dark">
    <b-navbar-brand>
      <b-navbar-nav v-if="isLogged">
        <b-nav-item
          align="start"
          v-b-toggle.sidebar-menu
          v-b-tooltip.hover
          title="Menu"
        >
          <b-icon icon="list"></b-icon>
        </b-nav-item>
      </b-navbar-nav>

    </b-navbar-brand>
    
    <b-navbar-brand
      href="#"
      @click="openurl('https://www.grupok1.com.br')"
      v-b-tooltip.hover
      title="Site oficial"
    >
      <img src="../assets/K1_Logo_BRANCO_NAV.png" style="width: 32px" />
    </b-navbar-brand>
    <b-navbar-nav>
      <b-nav-item
          v-if="isLogged"
          align="start"
          v-b-tooltip.hover
          title="Home"
          to="/"
        >
          <b-icon icon="house-fill"></b-icon>
        </b-nav-item>      
    </b-navbar-nav>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item
          v-if="!root"
          align="start"
          href="#"
          v-b-tooltip.hover
          :title="home.name"
          :to="home.route"
        >
          <b-icon icon="house-fill" />
        </b-nav-item>
        <slot name="leftbuttons"></slot>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <slot name="middlebuttons"></slot>
        <slot name="rightbuttons"></slot>
        <b-nav-item
          href="#"
          to="/login"
          v-b-tooltip.hover
          title="Entrar"
          v-if="!isLogged"
        >
          <b-icon-person-x></b-icon-person-x>
        </b-nav-item>

        <b-nav-item-dropdown
          right
          v-else
          v-b-tooltip.hover
          :title="gtxProfiler_DisplayName"
        >
          <template #button-content>
            <b-icon
              class="shakemerotate"
              icon="person-check-fill"
              v-if="isLogged"
            />
            <b-icon-person-x v-else></b-icon-person-x>
          </template>
          <b-dropdown-item
            href="#"
            justified
            @click="menuclick('LoginProperties')"
          >
            <b-icon-person-badge></b-icon-person-badge>
            <span class="pl-2">{{ gtxProfiler_DisplayName }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            v-if="gtxProfiler_DEV"
            @click="menuclick('Loadresources')"
          >
            <b-icon-cloud-arrow-down></b-icon-cloud-arrow-down>
            <span class="pl-2">Recarregar recursos</span>
          </b-dropdown-item>
          <b-dropdown-item variant="danger" href="#" @click="menuclick('Sair')">
            <b-icon-power></b-icon-power>
            <span class="pl-2">Sair</span>
          </b-dropdown-item>

          <!-- <b-dropdown-item href="#" to="/login" v-if="!isLogged">
            <b-icon-key></b-icon-key>
            <span class="pl-2">Entrar</span>
          </b-dropdown-item> -->
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "../services/apiservices";

export default {
  name: "NavBar",

  data() {
    return {
      root:
        this.$route.path !== "/home" ||
        this.$route.path !== "/login" ||
        this.$route.path !== "/" ||
        this.$route.path !== "",
      home: { route: "/", name: "Home" },
      isLogged:
        this.$cookies.get("token") && this.$cookies.get("token") !== ""
          ? true
          : false,
      focused: true,
    };
  },

  computed: {
    ...mapGetters("profilerStore", [
      "gtxProfiler_DisplayName",
      "gtxProfiler_DEV",
    ]),
  },

  beforeMount() {
    API.loginObserver.subscribe(this.onlogin);
    API.homepageObserver.subscribe(this.gohome);
  },

  destroyed() {
    API.loginObserver.unsubscribe(this.onlogin);
    API.homepageObserver.unsubscribe(this.gohome);
  },

  methods: {
    ...mapActions("caixasaidaStore", ["actCaixasaidaDel"]),
    ...mapActions("profilerStore", ["actProfilerGet", "actProfilerClear"]),
    openurl(url) {
      window.open(url, "_blank");
    },
    menuclick(menu) {
      this.$emit("menuclick", menu);
    },
    onlogin(auth) {
      //console.log("MainNavbar.onlogin", auth);
      this.isLogged = auth;
      if (!auth) {
        this.actCaixasaidaDel();
        this.$userLogged = "";
      } else {
        if (this.$cookies.get("token") && this.$cookies.get("token") !== "") {
          this.actProfilerGet();
        }
      }
    },
    gohome(home) {
      this.home = home;
      // console.log("gohome:", home);
    },
    appFocused(focused) {
      this.focused = focused;
      if (focused) {
        const isLogged =
          this.$cookies.get("token") && this.$cookies.get("token") !== ""
            ? true
            : false;
        if (isLogged !== this.isLogged && this.isLogged) {
          this.isLogged = false;
          this.$emit("menuclick", "EXPIRED");
          this.$root.toastdanger("Expirado o prazo de conexão");
          this.$root.navigate("/");
        }
        if (isLogged !== this.isLogged) {
          this.isLogged = isLogged;
        }
        if (!isLogged) {
          this.actCaixasaidaDel();
          this.actProfilerClear();
        }
      }
    },
  },
  // [Vue warn]: Error in callback for watcher "isLogged": "Error: [vuex] expects string as the type, but found object."
  // watch: {
  //   isLogged(auth) {
  //     //console.log("watch.isLogged:", auth);
  //     if (!auth) {
  //       this.actCaixasaidaDel();
  //     }
  //   },
  // },
};
</script>

<style>
.mainnav {
  height: 50px;
  background: linear-gradient(
    to right,
    rgba(235, 63, 93),
    rgba(239, 116, 56),
    rgba(233, 40, 110)
  );
}
</style>
